<!--
  Consolidated, shared render for the data-driven error list. Each entry is an ErrorMessage:
    - text              : i18n key or raw string — resolved via `| translate` (reactive).
                          When no translation key is found the value is rendered as-is.
    - translationParams : optional interpolation params forwarded to `| translate`.
    - onClick           : optional — wraps the text in a clickable link
    - template          : optional — fully replaces the default <div> render
    - className         : optional — overrides the default wrapper class
  Accepts an optional `extraClass` in the template context for context-specific styling (e.g. text centering).
-->
<ng-container *ngFor="let error of errorMessages;">

  <ng-container
    *ngIf="error.template; else defaultErrorRender"
    [ngTemplateOutlet]="error.template"
    [ngTemplateOutletContext]="{
      $implicit: error,
      error: error,
      extraClass: extraClass
    }">
  </ng-container>

  <ng-template #defaultErrorRender>
    <div [ngClass]="getErrorClass(error)">

      <a
        *ngIf="error.onClick; else plainText"
        href="javascript:void(0)"
        class="nav-link"
        (click)="error.onClick()">
        {{ error.text | translate:error.translationParams }}
      </a>

      <ng-template #plainText>
        {{ error.text | translate:error.translationParams }}
      </ng-template>

    </div>
  </ng-template>

</ng-container>
